var React = require('react');

function TiktokFooterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0579 1.68473L11.639 1H9.10449V7.16708L9.09586 13.1909C9.10017 13.2357 9.10449 13.2849 9.10449 13.3297C9.10449 14.8379 7.92142 16.0686 6.462 16.0686C5.00259 16.0686 3.81952 14.8424 3.81952 13.3297C3.81952 11.8215 5.00259 10.5908 6.462 10.5908C6.76425 10.5908 7.05786 10.6489 7.32988 10.7474V7.73993C7.04922 7.6907 6.75993 7.66385 6.462 7.66385C3.4525 7.66832 1 10.2103 1 13.3342C1 16.458 3.4525 19 6.46632 19C9.48014 19 11.9326 16.458 11.9326 13.3342V6.16907C13.025 7.30134 14.437 8.40676 16 8.76032V5.68573C14.3031 4.90701 12.6149 2.60666 12.0579 1.68473Z","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round"}));
}

TiktokFooterIcon.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"};

module.exports = TiktokFooterIcon;

TiktokFooterIcon.default = TiktokFooterIcon;
